import { TicketService } from '../services/TicketService';

export function useTicketService(): TicketService {
  return new TicketService(useApiClient(), useUserStore());
}
